import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtMXN } from "@/lib/api";
import { Card } from "@/components/ui/card";

const COLUMNS = [
  { key: "borrador", label: "Borrador", color: "border-t-zinc-400" },
  { key: "enviada", label: "Enviada", color: "border-t-blue-500" },
  { key: "aceptada", label: "Aceptada c/ P.O.", color: "border-t-emerald-500" },
];

export default function Pipeline() {
  const [quotes, setQuotes] = useState([]);
  const nav = useNavigate();
  const load = () => api.get("/quotations").then((r) => setQuotes(r.data));
  useEffect(() => { load(); }, []);

  const onDrop = async (e, status) => {
    const id = e.dataTransfer.getData("id");
    const q = quotes.find((x) => x.id === id);
    if (!q || q.estatus === status || q.estatus === "aceptada") return;
    if (status === "enviada" && q.estatus === "borrador") {
      await api.post(`/quotations/${id}/send`); load();
    }
  };

  return (
    <div className="space-y-6">
      <div><h1 className="text-3xl font-heading font-bold tracking-tight">Pipeline Comercial</h1><p className="text-muted-foreground text-sm">Arrastra las tarjetas para avanzar el embudo de ventas.</p></div>
      <div className="grid md:grid-cols-3 gap-6">
        {COLUMNS.map((col) => {
          const cards = quotes.filter((q) => q.estatus === col.key);
          const total = cards.reduce((s, q) => s + q.subtotal, 0);
          return (
            <div key={col.key} onDragOver={(e) => e.preventDefault()} onDrop={(e) => onDrop(e, col.key)} data-testid={`kanban-col-${col.key}`}>
              <div className={`bg-white border border-border border-t-4 ${col.color} rounded-lg p-4`}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-heading font-semibold">{col.label}</h3>
                  <span className="text-xs text-muted-foreground">{cards.length} · {fmtMXN(total)}</span>
                </div>
                <div className="space-y-3 min-h-[200px]">
                  {cards.map((q) => (
                    <div key={q.id} draggable onDragStart={(e) => e.dataTransfer.setData("id", q.id)}
                      onClick={() => nav(`/app/cotizaciones/${q.id}`)}
                      className="border border-border rounded-lg p-3 bg-white cursor-grab hover:shadow-md transition-shadow active:cursor-grabbing" data-testid="kanban-card">
                      <div className="font-mono text-xs text-muted-foreground">{q.folio}</div>
                      <div className="font-medium text-sm">{q.client_snapshot?.razon_social}</div>
                      <div className="flex justify-between items-center mt-2">
                        <span className="font-semibold text-sm">{fmtMXN(q.total)}</span>
                        <span className={`text-xs ${q.margen_pct < 15 ? "text-red-500" : "text-emerald-600"}`}>{q.margen_pct}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
